import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BrokerTabLockService } from './services/broker-tab-lock.service';

/** Solo una pestaña puede tener /broker abierto (el guard casa por path, así que cubre también /broker?cuenta=). */
@Injectable({ providedIn: 'root' })
export class BrokerTabGuard {
  constructor(private brokerTabLock: BrokerTabLockService, private router: Router, private toastr: ToastrService) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (await this.brokerTabLock.acquire()) return true;
    this.toastr.error('El broker ya está abierto en otra pestaña', 'Broker', { timeOut: 5000 });
    // Navegación interna desde otra ruta: quedarse donde está; acceso directo por URL: ir al inicio
    return this.router.navigated ? false : this.router.parseUrl('/');
  }
}
